import DashboardGenComponent from "@/components/DashboardGenComponent.tsx";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import DashboardClass from "@/utils/dashboard_class.ts";
import React, {useEffect, useRef, useState} from "react";
import st from "@/styles/PendingLoans.module.scss";
import {useAtom} from "jotai/index";
import {pending_loans, popping_notifications} from "@/atoms/common.ts";
import {CircularProgress} from "@mui/joy";
import CreditApplicationInterface from "@/types_and_interfaces/credit_application_interface.ts";
import LazyImage from "@/ui/LazyImage.tsx";
import Images from "@/utils/images.ts";
import InfoIcon from "@/svg/InfoIcon.tsx";
import Button from "@/ui/Button.tsx";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import CalculatorIcon from "@/svg/CalculatorIcon.tsx";
import LoanApplicationTypesInterface from "@/types_and_interfaces/loan_types_interface.ts";
import Factories from "@/utils/factories.ts";
import {ApplicationStatus} from "@/types_and_interfaces/types.ts";
import useLoans from "@/hooks/loans.ts";
import Application from "@/components/Application.tsx";
import SignButKYCNotAllowedListener from "@/components/SignButKYCNotAllowedListener.tsx";
import {application_keys} from "@/utils/constants.ts";
import clsx from "clsx";
import {CircleChevronDown} from "lucide-react";
import {ApplicationsAndCrLineStatuses} from "@/types_and_interfaces/enums.ts";


const PendingLoans = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [applications] = useAtom(pending_loans);
    const typed_appl = applications as LoanApplicationTypesInterface
    const [poppings] = useAtom(popping_notifications)
    const loans = useLoans()
    const once_ran_ref = useRef<boolean>(false)


    useEffect(() => {
        const loans_handler = async () => {
            if(typeof applications === undefined || (typeof applications === "object" && Object.keys(applications).length === 0)) {
                await loans.updPendingLoans()
            }
        };

        loans_handler();

    }, []);

    
    useEffect(() => {
        if(once_ran_ref.current) {
            if(Array.isArray(poppings) && poppings.length) {
                let upd_loans_notif = poppings.find((x) => x.type === "loan_status_changed")
                if(upd_loans_notif) {
                    loans.updPendingLoans()
                }
            }
        }
        
        once_ran_ref.current = true
    }, [poppings]);


    
    
    const approvedApplications = applications  && typeof typed_appl.approved !== 'undefined' ? typed_appl.approved : [];
    const approvedNotVerified = applications  && typeof typed_appl.approved_and_not_verified !== 'undefined' ? typed_appl.approved_and_not_verified : [];
    const approvedGotToSign = applications  && typeof typed_appl.approved_and_need_sign !== 'undefined' ? typed_appl.approved_and_need_sign : [];
    const disbursed = applications  && typeof typed_appl.disbursed !== 'undefined' ? typed_appl.disbursed : [];
    const all_approved = [...approvedApplications, ...approvedNotVerified, ...approvedGotToSign, ...disbursed]

    return (
        <DashboardGenComponent
            responsive1
            header_type={"secondary"}
            onBackClick={()=>{
                navigate(DashboardClass.dashboard_routes.Home)
            }}
            header_content={
                <div className={st.header_content}>
                    <SignButKYCNotAllowedListener applications={all_approved} />
                    <h3>{t("pending_credit")}</h3>
                    
                    {
                        ((typeof applications === "object") && (
                            applications.hasOwnProperty("pending_submission") ||
                            applications.hasOwnProperty("submitting") ||
                            applications.hasOwnProperty("pending_approval") ||
                            applications.hasOwnProperty("approved") ||
                            applications.hasOwnProperty("more_data_and_not_verified") ||
                            applications.hasOwnProperty("more_data_and_verified") ||
                            applications.hasOwnProperty("approved_and_not_verified") ||
                            applications.hasOwnProperty("approved_and_need_sign") ||
                            applications.hasOwnProperty("approved_and_not_valid_data"))
                        ) ? null : (
                            <OpenCalcBtn />
                        )
                    
                    }
                    
                    {Array.isArray(all_approved) && all_approved?.length > 0 ? (
                        all_approved?.map((app, i) => {
                            
                            return (
                                <Application
                                    order={i}
                                    simplified_status={
                                        Factories.application_status_simplification(app.status)
                                    }
                                    application={app}
                                    key={`application_${app.id}`}
                                />
                            )
                        })
                    ) : (
                        <LazyImage
                            className={st.header_content_image}
                            src={Images.common.sunduc}
                            alt={"sunduc"}
                        />
                    )}
                </div>
            }
            
            column_center={
               <Center applications={applications} />
            }
        />
    )
}


interface CenterProps {
    applications: {} | LoanApplicationTypesInterface | undefined
}

const Center:React.FC<CenterProps> = ({applications}) => {
    const { t } = useTranslation();
    // const navigate = useNavigate();
    // const location = useLocation();
    
    
    // useEffect(() => {
    //     const params = new URLSearchParams(location.search);
    //     if (!params.has("more")) {
    //         params.set("more", "0");
    //         navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    //     }
    // }, [location, navigate]);
    
    
    return (
        <div
            className={st.column_center}
        >
            {typeof applications === "object" ? (
                <>
                    {Object.keys(applications).length ? application_keys.map((k: string, i: number) => {
                        const key = k as ApplicationsAndCrLineStatuses;
                        // const first_key = Object.keys(applications)[0]
                        
                        
                        const is_approved = (key: any) => {
                            return Boolean(key === "approved" || key === "approved_and_not_verified" || key === "approved_and_need_sign")
                        }
                        
                        const is_failed = (key: any) => {
                            return Boolean(key === "failed" )
                        }
                        
                        return (
                            <React.Fragment key={`index_of_appl_${i}`}>
                                

                                
                                {/*@ts-ignore*/}
                                {(Array.isArray(applications[key])) ? (
                                    <ApplicationsList
                                        is_approved={is_failed(key)}
                                        k={key}
                                        is_failed={is_approved(key)}
                                        //@ts-ignore
                                        applications={applications[key]}
                                    />
                                ) : null}
                                
                            </React.Fragment>
                        )
                        
                        return null;
                    }) : (
                        <div className={st.application_lack}>
                            <InfoIcon/>
                            {t("no_active_applications")}
                        </div>
                    )}
                    
                    {(Object.keys(applications).length === 1 && Object.keys(applications)[0].toLowerCase() === "failed" ) ? (
                        <div className={st.application_lack}>
                            <InfoIcon/>
                            {t("no_active_applications")}
                        </div>
                    ) : null}
                </>
            ) : (
                <div className={st.application_lack_progress}>
                    <CircularProgress color={"success"} size={"md"}/>
                </div>
            )}
        </div>
    )
}


interface PropsApplicationsList {
    applications: any[]
    is_approved:boolean
    is_failed:boolean
    k:ApplicationsAndCrLineStatuses
}

const ApplicationsList:React.FC<PropsApplicationsList> = ({applications, is_approved, is_failed, k}) =>{
    const { t } = useTranslation();
    const [more, set_more] = useState<number>(1)
    const n = 10
    const stat: ApplicationStatus = Factories.application_status_simplification(k)
    
    let key: ApplicationsAndCrLineStatuses = k
    
    if(key === "canceled") key = ApplicationsAndCrLineStatuses.canceled1
    // else if (key === "transmission_error") key = "pending_approval"
    else if (key === "transmission_error") key = ApplicationsAndCrLineStatuses.pending_approval
    
    return (!is_approved && !is_failed) && (
        <>
            
            <div className={st.basic_text}>
                <span>
                    { key === "loan_already_exist" ? t("repeated_loans") : t(key)}
                </span>
                
                <span className={clsx(st.badge, st[stat])}>
                    {applications.length}
                </span>
            </div>
            
            {applications.slice(0, more * n).map((obj, i:number) => {
                
                return (
                    <Application
                        order={i}
                        simplified_status={stat}
                        application={obj as CreditApplicationInterface}
                        key={`application_${(obj as CreditApplicationInterface).id}`}
                    />
                )
            })}
            
            {applications.length > n * more ? (
                
                <div className={st.more_controllers}>
                    
                    <span>
                        {t("are_left")} {applications.length - n * more}
                    </span>
                    
                    <Button outlined onClick={() => set_more(x => x + 1)}>
                        {t("see_more")}
                        <CircleChevronDown />
                    </Button>
                </div>
                
            ) : null}
            
            <br/>
        </>
    )
}


const OpenCalcBtn = () => {
    const {t} = useTranslation()
    return (
        <Button light className={st.new_credit_btn} onClick={() => {
            eventEmitter.emit(CommonClass.ModalEvents.OpenCalculator, true);
        }}>
            <CalculatorIcon/>
            {t("new_credit")}
        </Button>
    )
}

export default PendingLoans